import QuestionSets from 'text!app-question-sets';
import faqConfig from 'text!portal/config/faq.json';
import facebookConfig from 'text!portal/config/facebook.json';
import campaignUrlParamsConfig from 'text!portal/config/campaignUrlParams.json';
import rootTemplate from 'text!portal/views/root.html';
import 'angularRouter';
import 'gw-portals-tracking-angular';
import 'gw-portals-tracking-angular/adapters/module';
import AuthConfigUtil from 'gw-portals-auth-js/utils/AuthConfigUtil';
import AppConfig from 'ama/edge/quoteandbind/ama/cpp/config/AppConfig';

// Connects to localhost by default.
// Options: 'http://uxui-dev.guidewire.com'
var HOST_RUN_TIME = /* hostRunTime_START*/'//localhost' + (location.port ? ':' + location.port : '') /* hostRunTime_END*/;

// Flag to separate /app (Dev) and distribution builds
var IS_DISTRIBUTION_BUILD = /* DISTRIBUTION_BUILD_START*/true /* DISTRIBUTION_BUILD_END*/;

var eventAdapterModules = ['gw-portals-tracking-angular.adapters'];

/**
 * Module used to define application level configuration parameters that should be
 * passed to capability modules
 */

export default angular.module('portal.config', ['ui.router', 'gw-portals-tracking-angular'].concat(eventAdapterModules)).config(['adapters.googleAnalyticsProvider', 'CredentialsProvider', function (googleAnalyticsProvider, credentialsProvider) {
    var AMAConfig = new AppConfig();
    googleAnalyticsProvider.enablePlugin('ecommerce').configure(AMAConfig.get('googleAnalyticsCode'));
}]).config(['adapters.segmentIOProvider', 'CredentialsProvider', function (segmentIOProvider, credentialsProvider) {
    segmentIOProvider.configure(credentialsProvider.getCredentials('segmentIO'));
}]).config(['adapters.googleTagManagerProvider', function () {}]).config(['EventHubProvider', function (EventAdapterProvider) {
    EventAdapterProvider
    /* Sends every journey event to the console. For debugging purposes only
    .register({
        serviceName: 'console',
        handler: 'log'
    }) */
    .register({
        serviceName: 'console',
        handler: 'log'
    }).register({
        serviceName: 'googleAnalytics',
        handler: 'trackPageView',
        category: 'tracking',
        eventName: 'pageView'
    }).register({
        serviceName: 'googleAnalytics',
        handler: 'trackServerCall',
        category: 'tracking',
        eventName: 'serverCall'
    })
    /* Stores every journey event in the browser local storage. For debugging purposes only
     .register({
     serviceName: 'localstorage',
     handler: 'onEvent'
     }) */
    .register({
        serviceName: 'googleAnalytics',
        handler: 'trackServerCallError',
        category: 'tracking',
        eventName: 'serverCallError'
    }).register({
        serviceName: 'googleAnalytics',
        handler: 'trackServerCallError',
        category: 'tracking',
        eventName: 'serverCallError'
    }).register({
        serviceName: 'googleAnalytics',
        handler: 'fieldTrackCallback',
        category: 'fieldTracking',
        eventName: 'fieldTracking'
    }).register({
        serviceName: 'segmentIO',
        handler: 'trackJourney',
        category: 'tracking',
        eventName: 'journey'
    }).register({
        serviceName: 'segmentIO',
        handler: 'trackPageView',
        category: 'tracking',
        eventName: 'pageView'
    }).register({
        serviceName: 'segmentIO',
        handler: 'trackServerCall',
        category: 'tracking',
        eventName: 'serverCall'
    }).register({
        serviceName: 'segmentIO',
        handler: 'trackServerCallError',
        category: 'tracking',
        eventName: 'serverCallError'
    }).register({
        serviceName: 'segmentIO',
        handler: 'fieldTrackCallback',
        category: 'fieldTracking',
        eventName: 'fieldTracking'
    }).register({
        serviceName: 'googleTagManager',
        handler: 'trackPageView',
        category: 'tracking',
        eventName: 'pageView'
    }).register({
        serviceName: 'googleTagManager',
        handler: 'trackPageView',
        category: 'tracking',
        eventName: 'pageView'
    }).register({
        serviceName: 'googleTagManager',
        handler: 'trackServerCall',
        category: 'tracking',
        eventName: 'serverCall'
    }).register({
        serviceName: 'googleTagManager',
        handler: 'trackServerCallError',
        category: 'tracking',
        eventName: 'serverCallError'
    }).register({
        serviceName: 'googleTagManager',
        handler: 'trackServerCallError',
        category: 'tracking',
        eventName: 'serverCallError'
    }).register({
        serviceName: 'googleTagManager',
        handler: 'fieldTrackCallback',
        category: 'fieldTracking',
        eventName: 'fieldTracking'
    });
}])

/**
 * Defines the prefix url where the set of states for a sub module should
 * plug into the portal application
 */
.constant('state_plugin_config', {
    quote_bind: 'root',
    home: 'zipCode',
    quickQuote: 'quickQuote',
    faq: 'root'
}).constant('httpSettings', {
    'timeout': 90000,
    'reloadQueryParamName': 'goto',
    'reloadURL': '/index.html',
    'serviceBaseURLs': {
        'pc': '/pc/service/edge/',
        'quote': '/quote/',
        'vinlookup': '/vehicleinfo/',
        'availability': '/quote/',
        'addressLookup': '/address/',
        'guidance': '/guidance/',
        'propertycode': '/propertycode/'
    }
}).constant('defaultLocaleDetails', {
    countryCode: 'US',
    mapCenter: {
        lat: 37.923933,
        lon: -122.5203
    }
})

// Used for date of birth dropdowns.
.constant('AgeAllowedToDrive', 16).constant('MaximumAge', 100).constant('maxFileUploadSize', 50000000) // 50MB. Used to specify the maximum file size for document upload.

.config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
    var states = [{
        name: 'root',
        url: '',
        template: rootTemplate,
        abstract: true
    }];

    for (var i = 0; i < states.length; i++) {
        $stateProvider.state(states[i]);
    }

    $urlRouterProvider.when('home', 'zipCode');
    $urlRouterProvider.otherwise('zipCode');
}]).constant('ASYNC_TRANSLATIONS', true) // Constant that allows us to load translations synchronously (tests/Components Examples)
.constant('ANGULARI18N_PRESET', '') // Constant that allows us to load Angular Locale from different path (Components Examples)
.constant('TRANSLATE_PROVIDER_PREFIX', './js/i18n/translations/') // Constant that allows us to load translations from different path (Components Examples)
.constant('QUESTION_SETS_CONFIG', JSON.parse(QuestionSets)).constant('FAQ_CONFIG', JSON.parse(faqConfig)).constant('FACEBOOK_CONFIG', JSON.parse(facebookConfig)).constant('CAMPAIGN_PARAMS_CONFIG', JSON.parse(campaignUrlParamsConfig)).constant('oAuth', function () {
    var clientId = AuthConfigUtil.getPortalClientId('CustomerEngage-Quote_and_Buy', IS_DISTRIBUTION_BUILD);

    return {
        clientId: clientId
    };
}()).constant('sessionConfig', {
    inactivityIntervalMins: 5,
    logoutConfirmationIntervalMins: 1
});


//////////////////
// WEBPACK FOOTER
// ./dist/js/portal/config.js
// module id = 31
// module chunks = 0